import { useTimeKeeper } from "components/routes/events/useTimeKeeper";
import { Heat } from "graphql/generated/types";
import { useEffect } from "react";
import endHeatSiren from "./normalized_end_heat_siren.m4a";
import { useAudio } from "./useAudio";
import { usePrevious } from "hooks/usePrevious";

interface EndSirenAudioProps {
    isMuted: boolean;
    heat: Partial<Heat>;
}

export const useEndSirenAudio = ({ isMuted, heat }: EndSirenAudioProps) => {
    const { play } = useAudio(endHeatSiren);

    const heatStartTime = heat.startTime!;
    const remainingTime = useTimeKeeper({
        start: heatStartTime,
        duration: heat.heatDurationMinutes!,
        remainingMillisecondsOnPause: heat.remainingMillisecondsOnPause!,
        resume: heat.resumeTime!,
    });
    const remainingTimeInMilliseconds = Math.floor(
        remainingTime.asMilliseconds(),
    );
    const prevTimeRemaining = usePrevious(remainingTimeInMilliseconds);

    useEffect(() => {
        if (isMuted) return;
        if (
            prevTimeRemaining &&
            prevTimeRemaining >= 0 &&
            remainingTimeInMilliseconds === 0
        )
            play();
    }, [isMuted, prevTimeRemaining, remainingTimeInMilliseconds]);
};
